import {
  assertNativeCapabilities,
  assertNativePurchaseResult,
  NativeCapabilityUnavailableError,
  resolveNativeBridge,
  type NativeStoreProvider,
} from '@aztec-realms/native-bridge';

import {
  beginCheckout,
  fetchNativeStoreContext,
  submitNativeReceipt,
  type CheckoutResult,
} from './shop-api';

export async function beginPlatformCheckout(
  host: object,
  productCode: string,
  idempotencyKey: string,
): Promise<CheckoutResult> {
  const bridge = resolveNativeBridge(host);
  if (!bridge) return beginCheckout(productCode, idempotencyKey);

  const capabilities = assertNativeCapabilities(await bridge.getCapabilities());
  if (capabilities.commerce === 'unavailable') {
    throw new NativeCapabilityUnavailableError('commerce');
  }
  const expectedProvider: NativeStoreProvider =
    capabilities.commerce === 'storekit2' ? 'apple_app_store' : 'google_play';
  const storeContext = await fetchNativeStoreContext(expectedProvider);
  const product = storeContext.products.find((item) => item.productCode === productCode);
  if (!product) throw new Error('This product is unavailable from the native store');
  const purchase = assertNativePurchaseResult(
    await bridge.purchase({
      productCode,
      providerProductRef: product.providerProductRef,
      accountBinding: storeContext.accountBinding,
      idempotencyKey,
    }),
    productCode,
  );
  if (purchase.provider !== expectedProvider) {
    throw new Error('The native store provider did not match the signed application platform');
  }
  return submitNativeReceipt(purchase.provider, productCode, purchase.receipt);
}
